import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from 'react';

import LoginPage from './telas/LoginPage';
import UserRegistration from './telas/UserRegistration';
import CadastroEmpresa from './telas/CadastroEmpresa';
import HomePage from './telas/HomePage';
import CadastroServico from './telas/CadastroServico';
import Clientes from './telas/Clientes';
import Relatorios from './telas/Relatorios';
import SettingsPage from "./telas/SettingsPage";
import OrdemServicoView from './telas/OrdemServicoView';
import OrdemServico from './telas/OrdemServico';
import ServerInfo from './telas/ServerInfo';
import BackupManager from './telas/BackupManager';
import Saques from './telas/Saques';
import Depositos from './telas/Depositos';
import Produtos from './telas/Produtos';
import RequerimentoDetranPage from './telas/RequerimentoDetranPage';
import RequerimentosPage from './telas/RequerimentosPage';
import ProtocoloAtendimento from './telas/ProtocoloAtendimento';
import PainelCRVA from './telas/PainelCRVA';
import DocumentosComplementares from './telas/DocumentosComplementares';
import Veiculos from './telas/Veiculos';
import AreaFiscal from './telas/AreaFiscal';
import OficiosMemorandos from './telas/OficiosMemorandos';
import Agenda from './telas/Agenda';
import SelecionarEmpresa from './telas/SelecionarEmpresa';
import Digitalizacao from './telas/Digitalizacao';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index path="/login" element={<LoginPage />} />
        <Route path="/" element={<LoginPage />} />
        <Route path="/usuarios" element={<UserRegistration />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/cadastroEmpresas" element={<CadastroEmpresa />} />
        <Route path="/cadastroServico" element={<CadastroServico />} />
        <Route path="/relatorios" element={<Relatorios/>} />
        <Route path="/settings" element={<SettingsPage/>} />
        <Route path="/ordemServico" element={<OrdemServicoView/>} />
        <Route path="/criar-editar-ordemServico/:id?" element={<OrdemServico/>} />
        <Route path="/server-info" element={<ServerInfo/>} />
        <Route path="/backups-crons" element={<BackupManager/>} />
        <Route path="/saques" element={<Saques/>} />
        <Route path="/depositos" element={<Depositos/>} />
        <Route path="/produtos" element={<Produtos/>} />
        <Route path="/clientes" element={<Clientes/>} />
        <Route path="/requerimentos" element={<RequerimentosPage />} />
        <Route path="/requerimento-detran" element={<RequerimentoDetranPage />} />
        <Route path="/documentos-complementares/:tipo?" element={<DocumentosComplementares />} />
        <Route path="/veiculos" element={<Veiculos />} />
        <Route path="/protocoloAtendimento" element={<ProtocoloAtendimento />} />
        <Route path="/painel-crva" element={<PainelCRVA />} />
        <Route path="/area-fiscal" element={<AreaFiscal />} />
        <Route path="/oficios-memorandos" element={<OficiosMemorandos />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/selecionar-empresa" element={<SelecionarEmpresa />} />
        <Route path="/digitalizacao" element={<Digitalizacao />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
